import React from "react";

function Color_W3CSS() {
  return (
    <div>
      <h1>Color_W3CSS Component</h1>
      <p>This is the Color W3CSS tutorial page content.</p>
    </div>
  );
}

export default Color_W3CSS;
